<template>
  <svg width="50" height="50" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <rect x="30" y="20" width="40" height="15" fill="blue"/>
    <rect x="30" y="40" width="40" height="15" fill="green"/>
    <rect x="30" y="60" width="40" height="15" fill="red"/>
    <animateTransform attributeName="transform" type="translate" values="0 0; 0 5; 0 0" dur="1.5s" repeatCount="indefinite"/>
  </svg>
</template>
